<template>
<div>

  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="违规整改单">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="违规整改单" >
        <el-link type="primary" class="el-link-common"  @click="getFile('违规整改单.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="违规处理单">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="违规处理单" >
        <el-link type="primary" class="el-link-common"  @click="getFile('违规处理单.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="现场处理照片">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="现场处理照片" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="上报城管依据">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="上报城管依据" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="城管现场执法">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="城管现场执法" >
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "../FitmentFileSubgroup";
import AppConfig from "../../../../../../../../config/AppConfig";
export default {
  name: "PreparationForEntry",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{

    }
  },
  methods:{
    getFile(file_name) {
      let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/pda_check/ViolationManagement.vue